// extracted by mini-css-extract-plugin
export default {"btnGroupLabel":"ButtonGroup_btnGroupLabel__Osyo-","btnGroup":"ButtonGroup_btnGroup__l024B"};